<template >
  <v-dialog v-model="dialog" persistent="persistent" max-width="500">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("labels.service") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row="row">
          <v-autocomplete
            :items="services"
            :label="$t('labels.service')"
            item-text="selector"
            v-model="selectedService"
            item-value="id"
          ></v-autocomplete>
          <v-btn
            v-if="checkRightStatus(66)"
            color="info"
            :disabled="!selectedService"
            @click="addService(selectedService)"
            >Add Service</v-btn
          >
        </v-layout>
        <v-card>
          <v-toolbar class="elevation-0" height="45" color="gray">
            <v-toolbar-title>
              <h1 class="subheading">{{ $t("labels.serviceList") }}</h1>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-0">
            <v-list
              ><template v-for="(item, index) in location.ProductRelations">
                <v-list-tile
                  v-if="item.serviceID != 198"
                  :key="item.id"
                  ripple="ripple"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action v-if="checkRightStatus(57)">
                    <v-btn
                      icon="icon"
                      ripple="ripple"
                      @click="removeService(item)"
                    >
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < location.ProductRelations.length &amp;&amp; item.serviceID != 198"
                  :key="index"
                ></v-divider> </template
            ></v-list>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat="flat" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SERVICE } from "../../../../helper/Constant.js";
import locationService from "../service.js";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["serviceDialog"],
  data() {
    return {
      dialog: false,
      selectedService: null,
      services: [],
    };
  },
  async created() {
    await this.filterService();
  },
  async mounted() {
    await this.filterService();
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["checkRightStatus", "comboBoxByID"]),
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    filterService() {
      this.services = this.comboBoxByID(28).ComboBoxDetails.filter(
        (service) => service.id !== SERVICE.CSP4.ID
      );
    },
    removeService(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          return locationService
            .removeService(item.id)
            .then((response) => {
              console.log("response", response);
              if (response.data) {
                this.$swal("Deleted!", "Service has been removed!.", "success");
                this.$Progress.finish();
                this.$emit("saved");
              }
            })
            .catch((error) => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  type: "error",
                  title: err.data.message,
                });
              this.$Progress.fail();
            });
        }
      });
    },
    close() {
      this.$emit("close");
    },
    addService(id) {
      let index = _.findIndex(this.location.ProductRelations, function (x) {
        return x.serviceID == id;
      });
      if (index !== -1) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            type: "error",
            title: "Service already added!",
          });
      } else {
        locationService
          .addService(id, {
            storeID: this.location.storeID,
            organizationID: this.location.organizationID,
          })
          .then((result) => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                type: "success",
                title: "Service was added Successfully!",
              });
          });
        this.$emit("saved");
        this.setLocation(this.location.storeID);
        this.$router.go();
      }
    },
  },
  watch: {
    serviceDialog(val) {
      this.dialog = val;
    },
  },
};
</script>

<style scoped>
</style>